<template>
  <div>
    <filtros-letty
        :filtersView="filterView"
        :has-query-filters="!!queryFilters"
        :clear-query-filters="clear"
        v-on:filtros-aplicados="changeFilters"
    />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltrosLetty from '@/febos/global/_vue/componentes/FiltrosLetty';
import { getShareableFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import ConfigBillingFiltersMixin from '@/febos/global/billing/settings/ConfigBillingFiltersMixin';

export default {
  components: { FiltrosLetty },
  props: ['value', 'onChange', 'clear', 'defaultDate'],
  mixins: [ConfigBillingFiltersMixin],
  data() {
    const { view } = this.$route.params;
    return {
      view,
      currentFilters: '',
      queryFilters: this.$route.query.filters
    };
  },
  created() {
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany',
      'groupsCompany'
    ]),
    ...mapGetters('List', [
      'allDocumentsState',
      'institutionTypesState'
    ]),
    configuration() {
      return this.getFilterViewLetty(this.view, this.company.iut);
    },
    filterView() {
      return this.getFilterViewLetty(this.view, this.company.iut);
    }
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany'
    ]),
    async changeFilters(filters, onMounted) {
      this.currentFilters = filters;
      const newFilters = filters !== ''
        ? `${filters}`
        : '';

      if (!onMounted) {
        const nonShareableFilters = [
          ...(this.configuration.filtrosFijos || []).map((filterConfig) => filterConfig.campo)
        ];
        const queryFilters = getShareableFilters(newFilters, nonShareableFilters);
        updateSearchParams({ filters: queryFilters });
      }
      this.onChange(newFilters, onMounted);
    },
    clearQueryFilters() {
      removeSearchParams(['filters']);
      this.$router.go();
    }
  }

};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}

.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
